<div class="ion-header ion-hide-lg-up p">
  <header-main></header-main>
  <div class="ion-fab">
    <div class="ion-fab-button close button-tertiary button-round">
      <a href="/how-it-works">
        <img class="ion-icon" src="assets/icons/close.svg">
      </a>
    </div>
  </div>
</div>

<main class="ion-content" fullscreen>
  <header class="ion-hide-lg-down p">
    <header-desktop></header-desktop>
    <h1 color="white">
      <svg class="ion-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.03 26.17"><defs><style>.promote{stroke:none;}</style></defs><title>promote</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="promote" d="M17,12.78A7,7,0,1,0,6.7,10.06a7.56,7.56,0,0,0,1.08,1.61,7.44,7.44,0,0,0,1.27,1.11A13,13,0,0,0,0,25.17a1,1,0,0,0,1,1H18.49a1,1,0,0,0,0-2H2a11,11,0,0,1,22,1,1,1,0,0,0,2,0A13,13,0,0,0,17,12.78ZM8,7a5,5,0,1,1,1.26,3.32A5.19,5.19,0,0,1,8.5,9.19,5,5,0,0,1,8,7Z"></path></g></g></svg>
      How it works: Promote
    </h1>
  </header>

  <div class="container-fluid details-wrapper">
    <div class="row">
      <div class="col col-xs-12 col-md-10 col-lg-8 col-xl-6 col-md-offset-1 col-lg-offset-2 col-xl-offset-3">
        <div class="details-content">
          <img class="ion-margin-bottom" src="assets/images/how-it-works/promoter.jpg" alt="Promote">
          <div>
            <div class="description">
              <h1>gigexchange has been built by gig workers.</h1>
              
              <p>We appreciate how difficult it can be to promote your services, when the time comes to move on to your next gig, or just need new customers.</p>

              <p>This is why we created the Promote service within our marketplace.</p>
              
              <p>Whether you’re a contractor or freelancer looking to advertise your services and availability for your next gig. Or a business growing or needing new customers, we offer an affordable promotion page to advertise your brand and services, validated by our reputation service.</p>
              
              <p>We will provide an innovative search/notify function in the near future, allowing consumers, businesses or recruiters to search for immediately available on-demand workers, or service based businesses looking to grow, all for free!</p>
              
              <p>We can link your marketplace reputation to these promotions to validate your brands promotions.</p>
              
              <p>We will empower your win, when you promote your availability, attitude and ability through us.</p>
              
              <p>Watch this space for additional services and features to empower your win...!</p>
              
              <p>For more information see our <a routerLink="/support">Help Centre</a> &amp; <a href="/faqs">FAQs</a>.</p>
              
              <p>Promotional adverts are listed for 1 year and FREE until we all recover from Covid19</p>
              
              <h5>gig exchange - empowering the advertising win</h5>
            </div>
          </div>
          <div class="details-author">
            <p>Posted by: gigexchange</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-hide-lg-up">
  <footer-main></footer-main>
</footer>
